/** Study routes that replace the retired "My year" page (study-my-year-prd.md §3.2). */
export const STUDY_HOME_PATH = '/learn/study';
export const STUDY_JOURNEY_PATH = '/learn/study/journey';
export const STUDY_WRAP_UP_PATH = '/learn/study/wrap-up';
export const STUDY_SETTINGS_PATH = '/learn/study/settings';
/** Retired routes. Old links keep working through a replace redirect. */
export const RETIRED_STUDY_YEAR_PATH = '/learn/study/year';
export const RETIRED_STUDY_PLAN_PATH = '/learn/study/plan';

/** The query params an old `/learn/study/year` link may carry that My journey still reads. */
const JOURNEY_PARAMS = ['year', 'term'] as const;

/** `/learn/study/year?tab=…&year=…&term=…#x` becomes `/learn/study/journey?year=…&term=…#x`. */
export function journeyRedirectHref(search: string, hash: string): string {
  const from = new URLSearchParams(search);
  const next = new URLSearchParams();
  for (const key of JOURNEY_PARAMS) {
    const value = from.get(key);
    if (value) next.set(key, value);
  }
  const query = next.toString();
  return `${STUDY_JOURNEY_PATH}${query ? `?${query}` : ''}${hash}`;
}

/** A My journey link for one year and Term. `returnTo: 'wrap-up'` brings the story back. */
export function journeyHref(
  scope: { year?: string; term?: string; returnTo?: 'wrap-up' },
  hash = '',
): string {
  const next = new URLSearchParams();
  if (scope.year) next.set('year', scope.year);
  if (scope.term) next.set('term', scope.term);
  if (scope.returnTo) next.set('return', scope.returnTo);
  const query = next.toString();
  return `${STUDY_JOURNEY_PATH}${query ? `?${query}` : ''}${hash}`;
}
